module.exports = {
  name: 'fc-contact-us',
  settings: {
    set: [
      { width: '1024', height: '576', breakpoint: 'xs' },
      { width: '512', height: '288', breakpoint: 'xl' },
    ],
    ratio: null,
    fit: 'crop',
    align: 'center',
  },
}
